/*
 * @Description:
 * @Autor: qibiao
 * @Email: qibiao0508@163.com
 * @Date: 2023-11-20 10:19:35
 * @LastEditors: qibiao
 * @LastEditTime: 2023-11-23 18:39:21
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '*',
    redirect: '/home'
  },
  {
    name: 'home',
    component: () => import('./view/home'),
    meta: {
      title: 'TradeAider Partner',
      auth: true
    }
  },
  {
    name: 'login',
    component: () => import('./view/login'),
    meta: {
      title: 'TradeAider Partner',
      auth: false
    }
  },
  {
    name: 'partners',
    component: () => import('./view/partners'),
    meta: {
      title: 'TradeAider Partner',
      auth: true
    }
  },
  {
    name: 'gains',
    component: () => import('./view/gains'),
    meta: {
      title: 'TradeAider Partner',
      auth: true
    }
  },
  {
    name: 'activity',
    component: () => import('./view/activity'),
    meta: {
      title: 'TradeAider Vip Card',
      auth: false
    }
  },
  {
    name: 'activity/en',
    component: () => import('./view/activityEn'),
    meta: {
      title: 'TradeAider Vip Card',
      auth: false
    }
  }
]

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '')
})

const router = new Router({ routes })

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title
  if (title) {
    document.title = title
  }
  next()
})

export { router }
